// Flow types automatically removed

import formStyles from '../styles/FormGeneral.scss';
export const LastElement = ({ child }) => {
    return <div className={formStyles.lastElement}>{child}</div>;
};
